module.exports = __webpack_public_path__ + "static/media/Unauthorised401.6303b934.svg";